import { useState, useEffect } from 'react';
import { categories } from '@/mocks/categories';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [searchFocused, setSearchFocused] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    if (mobileOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => { document.body.style.overflow = ''; };
  }, [mobileOpen]);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <nav className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 shrink-0">
            <div className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
              <i className="ri-play-fill text-background-50 text-xl"></i>
            </div>
            <span className={`font-heading text-xl font-bold whitespace-nowrap ${scrolled ? 'text-foreground-950' : 'text-white'}`}>
              久久视频
            </span>
          </Link>

          <div className="hidden lg:flex items-center gap-1">
            <Link
              to="/"
              className="px-3 py-2 text-sm font-medium rounded-lg text-foreground-700 hover:text-primary-600 hover:bg-primary-50 transition-colors whitespace-nowrap"
            >
              首页
            </Link>
            {categories.slice(0, 6).map((cat) => (
              <Link
                key={cat.id}
                to={`/category/${cat.id}`}
                className="px-3 py-2 text-sm font-medium rounded-lg text-foreground-700 hover:text-primary-600 hover:bg-primary-50 transition-colors whitespace-nowrap"
              >
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className="px-3 py-2 text-sm font-medium rounded-lg text-foreground-700 hover:text-primary-600 hover:bg-primary-50 transition-colors whitespace-nowrap"
            >
              关于我们
            </Link>
          </div>

          <div className="hidden md:flex items-center gap-3">
            <div className={`relative transition-all duration-300 ${searchFocused ? 'w-64' : 'w-48'}`}>
              <i className={`ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-sm pointer-events-none transition-colors ${searchFocused ? 'text-primary-500' : 'text-foreground-400'}`}></i>
              <input
                type="text"
                placeholder="搜索视频..."
                onFocus={() => setSearchFocused(true)}
                onBlur={() => setSearchFocused(false)}
                className="w-full pl-9 pr-3 py-2 text-sm rounded-full bg-background-100 border border-background-200/70 focus:border-primary-400 focus:bg-background-50 focus:outline-none transition-all placeholder:text-foreground-400 text-foreground-800"
              />
            </div>
          </div>

          <button
            className="lg:hidden w-9 h-9 flex items-center justify-center rounded-lg text-foreground-700 hover:bg-background-100"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="菜单"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </nav>

      {mobileOpen && (
        <div className="lg:hidden bg-background-50 border-t border-background-200/70">
          <div className="px-4 py-3">
            <div className="relative mb-3">
              <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-sm text-foreground-400"></i>
              <input
                type="text"
                placeholder="搜索视频..."
                className="w-full pl-9 pr-3 py-2.5 text-sm rounded-full bg-background-100 border border-background-200/70 focus:border-primary-400 focus:outline-none text-foreground-800"
              />
            </div>
            <div className="flex flex-col gap-1">
              <Link
                to="/"
                onClick={() => setMobileOpen(false)}
                className="px-3 py-2.5 text-sm font-medium rounded-lg text-foreground-700 hover:text-primary-600 hover:bg-primary-50 transition-colors"
              >
                首页
              </Link>
              {categories.map((cat) => (
                <Link
                  key={cat.id}
                  to={`/category/${cat.id}`}
                  onClick={() => setMobileOpen(false)}
                  className="px-3 py-2.5 text-sm font-medium rounded-lg text-foreground-700 hover:text-primary-600 hover:bg-primary-50 transition-colors"
                >
                  {cat.name}
                </Link>
              ))}
              <Link
                to="/about"
                onClick={() => setMobileOpen(false)}
                className="px-3 py-2.5 text-sm font-medium rounded-lg text-foreground-700 hover:text-primary-600 hover:bg-primary-50 transition-colors"
              >
                关于我们
              </Link>
            </div>
          </div>
        </div>
      )}
    </header>
  );
}